import { Injectable } from '@angular/core';
import { AnnualReportTemplate } from '@vi-iot/client/apis/annual-report/annual-report.model';
import { Observable } from 'rxjs';

import { ClientService } from '@vi-iot/client';

@Injectable()
export class AnnualReportApi {
  constructor(private clientService: ClientService) {}

  createReportOnDemand(
    installationId: number,
    gatewaySerial: string,
    deviceId: string,
    reportTemplate: AnnualReportTemplate
  ): Observable<any> {
    const endpoint = `iot/v2/reports/installations/${installationId}/gateways/${gatewaySerial}/devices/${deviceId}/reports`;

    return this.clientService.post(endpoint, { reportTemplate: reportTemplate }, null);
  }

  getReport(processId: string): Observable<any> {
    const endpoint = `iot/v1/reports/reports/${processId}`;

    return this.clientService.get(endpoint, null);
  }
}
